<template>
  <router-link
    v-if="!route.external && route.route"
    class="link"
    :disabled="disabled"
    :event="disabled ? '' : 'click'"
    data-test="router-link"
    :to="route.route"
    @click="disabled ? '' : $emit('route-click')"
  >
    <span class="link__label">{{ label || route.label }}</span>
  </router-link>

  <a
    v-else-if="route.external && route.route"
    class="link"
    data-test="html-link"
    :href="route.route as string"
    target="_blank"
    rel="noopener"
  >
    <span class="link__label">{{ label || route.label }}</span>
  </a>

  <button
    v-else-if="!route.route && route.childRoutes"
    class="link"
    @click="$emit('show-child-routes', route)"
  >
    <span class="link__label">{{ label || route.label }}</span>
    <span class="link__icon"></span>
  </button>
</template>

<script setup lang="ts">
  import { NavigationLink } from '@/types/interfaces';

  defineEmits<{
    (e: 'route-click'): void
    (e: 'show-child-routes', v: NavigationLink): void
  }>();

  defineProps<{
    route: NavigationLink
    label?: string
    disabled?: boolean
  }>();
</script>

<style scoped lang="scss">
  .link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 16px;
    background: transparent;

    &__label {
      font-size: remc(14px);
      font-weight: inherit;
      line-height: remc(22px);
      color: $text-100-charcoal;

      &_title {
        margin-bottom: 0;
        color: $text-100-charcoal;
        background: $light-navy-40;
      }
    }

    &.router-link-active {
      font-weight: 600;
    }

    &__icon {
      width: 6px;
      height: 10px;
      background-color: transparent;
      background-image: url('@/assets/icons/chevron-right-blue.svg');
      background-repeat: no-repeat;
    }
  }
</style>
